(ns io.daskul.webapp.notifications
  "Notification helpers for re-frame events.

   Builds notification maps for the :notification effect.
   Single source of truth for notification colors.")

(defn success
  "Success notification (green)."
  [title message]
  {:title title :message message :color "green"})

(defn error
  "Error notification (red)."
  [title message]
  {:title title :message message :color "red"})
